import { render, staticRenderFns } from "./AssessmentWorkOrder.vue?vue&type=template&id=8a6fd6a6&scoped=true"
import script from "./AssessmentWorkOrder.vue?vue&type=script&lang=js"
export * from "./AssessmentWorkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fd6a6",
  null
  
)

export default component.exports